import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ObservatoryService, StorageService, FileExporterService } from '@services/services.module';
import { TranslateService } from '@ngx-translate/core';
import { CalendarService } from '@components/calendar/calendar.service';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DayData } from '@components/calendar/calendar-day/calendar-day.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-excel-resume',
  templateUrl: './excel-resume.component.html',
  styleUrls: ['./excel-resume.component.scss']
})
export class ExcelResumeComponent implements OnInit, OnDestroy {

  @Input() idEmp: number;
  private subscriptions: Array<Subscription> = [];
  public userData: any;
  public dayListToMonth: Array<DayData>;
  public arRepeatedMonth: any = [];
  public arRepeatedYear: any = [];
  public repeatedMonth: any;
  public repeatedYear: any;
  public ImputationsFilled = [];
  public initDate: string;
  public endDate: string;

  constructor(
    private router: Router,
    private observatory: ObservatoryService,
    public translate: TranslateService,
    public fileExporter: FileExporterService,
    public calendarService: CalendarService,
    private storage: StorageService,
    public calendar: NgbCalendar
  ) {
  }

  ngOnInit() {
    this.observatory.getData('dayListToMonth').subscribe(val => {
      if (val && val.length) {
        this.dayListToMonth = val;
        this.refreshDataExcel();
      }
    });
  }

  mostRepeatedInArray(array) {
    const counted = array.reduce((accumulator, current) => {
      if (current in accumulator) {
        accumulator[current]++;
      } else {
        accumulator[current] = 1;
      }
      return accumulator;
    }, {});

    const mostRepeated = Object.keys(counted).reduce((accumulator, current) => counted[accumulator] > counted[current] ? accumulator : current);

    return mostRepeated;
  }

  refreshDataExcel() {
    this.arRepeatedMonth = [];
    this.arRepeatedYear = [];
    this.repeatedMonth = '';
    this.repeatedYear = '';
    let month;
    let year;
    let day;
    const intMonth: any = [];

    this.userData = this.storage.get('userDataStorage');
    this.idEmp = this.userData.employeeNumber;
    for (const i in this.dayListToMonth) {
      if (typeof this.dayListToMonth[i] !== 'undefined') {
        month = this.dayListToMonth[i].date.substring(4, 6);
        year = this.dayListToMonth[i].date.substring(0, 4);
        this.arRepeatedMonth.push(month);
        this.arRepeatedYear.push(year);
      }
    }
    this.repeatedMonth = this.mostRepeatedInArray(this.arRepeatedMonth);
    this.repeatedYear = this.mostRepeatedInArray(this.arRepeatedYear);

    for (let k = 0; k < this.dayListToMonth.length; k++) {
      if (this.repeatedMonth === this.dayListToMonth[k].date.substring(4, 6)) {
        day = this.dayListToMonth[k].date.substring(0, 8);
        intMonth.push(day);
      }
    }
      this.initDate = intMonth[0];
      this.endDate = intMonth[intMonth.length - 1];
  }

  convertJson() {
    let employeeNumber = 0;
    if (this.router.url !== '/imputaciones') {
      this.observatory.getData('employeeNumber').subscribe(val => {
        if (val) {
          employeeNumber = val;
          this.fileExporter.getReportEmployee(this.endDate, this.initDate, employeeNumber);
        }
      });
    } else {
      this.dayListToMonth = this.storage.get('dayListToMonth');
      this.refreshDataExcel();
      this.userData = this.storage.get('userDataStorage');
      this.fileExporter.getReportEmployee(this.endDate, this.initDate, this.userData.employeeNumber);
    }
   }
   ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}
